<template>
  <div class="noum" style="padding: 15px 0">
    <div class="prop">
      <div class="props-wrap" v-for="(item, i) in data.content.props" :key="i">
        <div class="prop-hd">
          {{ item.propName }}
          <!-- {{ item.propId }} -->
        </div>
        <ul class="prop-bd">
          <li
            class="prop-item"
            :class="newcolor(opt.select)"
            v-for="(opt, j) in item.child"
            :key="j"
            @click="newoptid(item.propId, opt.optId)"
          >
            {{ opt.optName + "1" }}
            <!-- {{opt.optId}} -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* 1、导入方法 */
import { spedataAll, accdataAll } from "../network/home";
import { jiami } from "../util/sign.js";
/* 2、导入辅助计算函数 */
import { mapState } from "vuex";

import { getsperdata } from "../util/getData.js";

export default {
  data() {
    return {
      data: {
        content: {},
        data: {
          spedata: {}, //本体数据
          accdata: {}, //附件数据

          defaultSelected: [], //默认选中
          ShortName: "", //名称
          acckey: [],
        },
      },
      defoptstr: [] /* 层级id和选项id */,
    };
  },

  mounted() {
    this.alldata(this.sid);
  },

  computed: {
    ...mapState(["sid", "shortname", "defaultselect"]),
  },

  watch: {
    sid(newVal) {
      this.alldata(newVal);
    },
  },
  created() {
    console.log(123);
  },

  methods: {
    /* 1、请求数据 */
    alldata(id) {
      spedataAll(jiami(id)).then((res) => {
        console.log(res);
        this.data.data.spedata = res.data;
        // this.$store.commit('spedata',res.data)
        this.defid(res.data);
        accdataAll(jiami(id)).then((res) => {
          // this.$store.commit('accdata',res.data)
          this.data.data.accdata = res.data;
          this.data.data.defaultSelected = this.defaultselect;
          this.data.data.ShortName = this.shortname;
          this.data.content = getsperdata(this.data.data);
          // console.log(this.data.content);
          // this.$store.commit('content',this.data.content)
        });
      });
    },

    defid(res) {
      let pid = "",
        tid = "";
      this.defoptstr = [];
      for (let i = 0; i < res.spe_prop.length; i++) {
        this.defoptstr.push({
          tid: res.spe_prop[i].propId,
          pid: res.spe_prop[i].defaultSelected,
        });
      }
    },

    /* 判断选中选项 */
    newcolor(select) {
      if (select) {
        return "active";
      }
    },

    /* 选项动态变化时 */
    newoptid(tid, pid) {
      let arr = [];
      for (let i = 0; i < this.defoptstr.length; i++) {
        if (this.defoptstr[i].tid == tid) {
          this.defoptstr[i].pid = pid;
        }
        arr.push(this.defoptstr[i].pid);
      }
      this.data.data.defaultSelected = arr;
      console.log(arr);
      this.data.content = getsperdata(this.data.data);
      console.log(this.data.content);
      // this.$store.commit('content',this.data.content)
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/less/noum";
</style>